import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// CREATE ASSESSMENT
export const createAssessment = async (user, answers) => {
  try {
    // convert flat answers → grouped
    const grouped = {
      emotional: [],
      mental: [],
      physical: [],
      social: [],
      financial: []
    };

    Object.keys(answers).forEach(key => {
      const [dim, index] = key.split("_");
      grouped[dim][index] = answers[key];
    });

    const payload = {
      user_id: user?.id,
      answers: grouped
    };

    const response = await axios.post(
      `${API_BASE_URL}/wellness-score`,
      payload
    );

    return response;
  } catch (error) {
    console.error("Error creating assessment:", error);
    return null;
  }
};


export const getAssessmentHistory = async (userId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/wellness-scores/${userId}`
    );

    return response;
  } catch (error) {
    console.error("Error fetching assessment history:", error);
    return null;
  }
};

export const getOrganizationStats = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/organization-stats`
    );

    return response;
  } catch (error) {
    console.error("Error fetching organization stats:", error);
    return null;
  }
};

export const getSubjectiveWellBeingHistory = async (userId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/subjective-wellbeing/${userId}`
    );

    return response;
  } catch (error) {
    console.error("Error fetching subjective well-being history:", error);
    return null;
  }
};